import type { TFunction } from "react-i18next"
import { Trans } from "react-i18next"
import type { CalendarDuration } from "@oysterhr/schema"
import { timeWithUnit } from "../../hooks/useKBAdvisor/helpers"
import { FlagIcon } from "@oysterhr/ui"

export const introduction = (
  t: TFunction,
  countryName: string,
  countryCode: string,
  subdivisionName?: string,
) => {
  return (
    <Trans
      defaults={t("countryHighlights.introduction", {
        countryName: [countryName, subdivisionName].filter(Boolean).join(", "),
      })}
      components={{
        p: <p />,
        Flag: <FlagIcon className="w-4 pb-1" countryCode={countryCode} />,
      }}
    />
  )
}
export const probationText = (
  t: TFunction,
  statutory: CalendarDuration,
  recommeded: CalendarDuration | null,
) => {
  const recommendedText =
    !recommeded || statutory === recommeded
      ? "."
      : t("countryHighlights.probationPeriodRecommended", {
          maxRecommendedDuration: timeWithUnit(t, recommeded),
        })

  return (
    <Trans
      defaults={t("countryHighlights.maxProbationPeriod", {
        probationPeriodStatutory: t("countryHighlights.probationPeriodStatutory", {
          maxStatutoryDuration: timeWithUnit(t, statutory),
        }),
        probationPeriodRecommended: recommendedText,
      })}
    />
  )
}
